import { render, staticRenderFns } from "./Jpg.vue?vue&type=template&id=aeb76cf2"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aeb76cf2')) {
      api.createRecord('aeb76cf2', component.options)
    } else {
      api.reload('aeb76cf2', component.options)
    }
    module.hot.accept("./Jpg.vue?vue&type=template&id=aeb76cf2", function () {
      api.rerender('aeb76cf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/fileExtensions/Jpg.vue"
export default component.exports